import chat from './chat'
import call from './call'
// import ticket from './ticket'
import report from './report'

export default [
  {
    header: 'breadcrumb.conversation',
    resource: 'conversation-header',
  },
  ...chat,
  ...call,
  // ...ticket,
  ...report,
]
